import { Colors } from '@/common/colors/colors';
import Icon from '@/common/components/Icon';
import PopUp from '@/common/components/PopUp';
import SubmitButton from '@/common/components/buttons/SubmitButton';
import moment from 'moment';
import Form from '../../../../../common/components/Form';
import Input from '../../../../../common/components/Input';
import Loading from '../../../../../common/components/Loading';
import SelectInput from '../../../../../common/components/SelectInput';
import { COMPANIES_OPTIONS } from '../../../../../common/constants/Accounting';
import { CURRENCY } from '../../../../../common/constants/currency';
import UserRequestsLog from '../userRequests/UserRequestsLog';
import {
	AddManagerIconWrapper,
	BasicInfoWrapper,
	ButtonWrapper,
	ManagerInputWrapper,
	RequestsWrapper,
	RestInfoWrapper,
	SplitLine,
	Title,
	Wrapper,
} from './UserForm.styled';
import PersonalDocuments from './components/personalDocuments/PersonalDocuments';
import UserManagerForm from './components/userManagerForm/UserManagerForm';
import {
	ACCESS,
	CONSULTNAT_ROLE,
	ROLES,
	ROLE_HIDDEN_FIELDS,
} from './constants';
import useUserForm from './useUserForm';

const UserForm = ({ users, languageOptions }) => {
	const hook = useUserForm({ users, languageOptions });

	return (
		<>
			{hook.isLoading && <Loading />}
			<PopUp setShow={() => hook.setSearchParams({})} padding='10px 20px 30px'>
				<Wrapper>
					<Form onSubmit={hook.handleSubmit}>
						<Title>Basic Information</Title>
						<BasicInfoWrapper>
							<div>
								<Input
									color={Colors.darkBlue}
									inputRef={hook.nameRef}
									name='Name'
									value={hook.user?.name}
									required
									width={150}
								/>
								<Input
									color={Colors.darkBlue}
									inputRef={hook.surnameRef}
									name='Surname'
									value={hook.user?.surname}
									required
									width={150}
								/>
								<SelectInput
									color={Colors.darkBlue}
									name='Salary currency'
									options={CURRENCY}
									selected={hook.selectedCurrencyOption}
									setSelected={hook.setSelectedCurrencyOption}
									width={150}
									required
									hideStar
								/>
								<Input
									color={Colors.darkBlue}
									inputRef={hook.emailRef}
									name='Email'
									type='email'
									value={hook.user?.email}
									required
									width={150}
								/>
								<Input
									color={Colors.darkBlue}
									inputRef={hook.loginRef}
									name='Username'
									value={hook.user?.username}
									required
									width={150}
								/>
							</div>
							<div>
								<Input
									color={Colors.darkBlue}
									inputRef={hook.passwordRef}
									type='password'
									name='Password'
									value=''
									required={!hook.user}
									width={150}
								/>
								<SelectInput
									color={Colors.darkBlue}
									name='Language'
									options={languageOptions}
									setSelected={hook.setSelectedLanguageOption}
									selected={hook.selectedLanguageOption}
									width={150}
									required
									hideStar
								/>
								<SelectInput
									color={Colors.darkBlue}
									name='Company'
									options={COMPANIES_OPTIONS}
									setSelected={hook.setSelectedComapny}
									selected={hook.selectedCompany}
									width={150}
									required
									hideStar
								/>
								<SelectInput
									color={Colors.darkBlue}
									name='Roles'
									options={ROLES}
									setSelected={hook.setSelectedRolesOption}
									selected={hook.selectedRolesOption}
									setAccesses={hook.setSelectedAccessOption}
									width={150}
									required
									hideStar
								/>
								<Input
									color={Colors.darkBlue}
									type='checkbox'
									id='Active'
									name='Active'
									width={150}
									inputWidth={20}
									height={20}
									onChange={() => hook.setIsActive((prev) => !prev)}
									isChecked={hook.isActive}
								/>
							</div>
						</BasicInfoWrapper>
						{hook.isUserAdmin && (
							<SelectInput
								color={Colors.darkBlue}
								name='Access'
								options={ACCESS}
								setSelected={hook.setSelectedAccessOption}
								selected={hook.selectedAccessOption}
								multiple={true}
								selectWidth={720}
								width={250}
								required
								hideStar
							/>
						)}
						{!ROLE_HIDDEN_FIELDS[hook.selectedRolesOption?.value]?.includes(
							CONSULTNAT_ROLE,
						) && (
							<>
								<SplitLine />
								<Title>Rest Information</Title>
								<RestInfoWrapper>
									<div>
										<Input
											color={Colors.darkBlue}
											inputRef={hook.contractStartRef}
											name='Contract start'
											type='date'
											value={
												hook.user?.contract_start_date &&
												moment(hook.user.contract_start_date).format(
													'YYYY-MM-DD',
												)
											}
											width={250}
										/>
										<Input
											color={Colors.darkBlue}
											inputRef={hook.contractEndRef}
											name='Contract end'
											type='date'
											value={
												hook.user?.contract_end_date &&
												moment(hook.user.contract_end_date).format('YYYY-MM-DD')
											}
											width={250}
										/>
										<Input
											color={Colors.darkBlue}
											inputRef={hook.contractTypeRef}
											name='Contract type'
											value={hook.user?.contract_type}
											required
											width={250}
										/>
										<Input
											color={Colors.darkBlue}
											inputRef={hook.contractHoursRef}
											name='Contract hours'
											value={hook.user?.contract_hours}
											required
											width={250}
										/>
										<Input
											color={Colors.darkBlue}
											inputRef={hook.vacationDaysRef}
											name='Vacation days'
											value={hook.user?.vacation_days}
											required
											width={250}
										/>
										<Input
											color={Colors.darkBlue}
											inputRef={hook.monthHoursRef}
											name='Month hours'
											value={hook.user?.month_hours}
											required
											width={250}
										/>
										<Input
											color={Colors.darkBlue}
											inputRef={hook.bankAccountNumberRef}
											name='Bank account number'
											value={hook.user?.bank_account_number}
											required
											width={250}
										/>
									</div>
									<div>
										<ManagerInputWrapper>
											<SelectInput
												color={Colors.darkBlue}
												name='Superior'
												options={hook.managers}
												setSelected={() => {}}
												selected={hook.managers?.find(
													(o) => o.value === hook.getCurrentManager(),
												)}
												width={150}
												selectWidth={210}
												disabled
											/>
											<AddManagerIconWrapper
												onClick={() => hook.setShowManagerForm(true)}
											>
												<Icon size={18} name='plus' />
											</AddManagerIconWrapper>
										</ManagerInputWrapper>
										<Input
											color={Colors.darkBlue}
											inputRef={hook.voipIdRef}
											type='number'
											name='Voip id'
											value={hook.user?.voip_id}
											width={150}
										/>
										<Input
											color={Colors.darkBlue}
											inputRef={hook.callingSystemRef}
											id='calling_system'
											type='checkbox'
											name='Calling system'
											checked={hook.user?.calling_system}
											width={150}
											inputWidth={20}
											height={20}
										/>
										{hook.user && (
											<div style={{ marginLeft: '40px' }}>
												<PersonalDocuments
													user={hook.user}
													userId={hook.user._id}
												/>
											</div>
										)}
									</div>
								</RestInfoWrapper>
							</>
						)}
						<ButtonWrapper>
							<SubmitButton text='Save' />
						</ButtonWrapper>
					</Form>
					<RequestsWrapper>
						{hook.user && <UserRequestsLog userId={hook.user._id} />}
					</RequestsWrapper>
				</Wrapper>
				{hook.showManagerForm && (
					<UserManagerForm
						managers={hook.managers}
						userManagers={hook.userManagers}
						setShow={hook.setShowManagerForm}
						setUserManagers={hook.setUserManagers}
					/>
				)}
			</PopUp>
		</>
	);
};

export default UserForm;
